export default {
  state: {
    snackbar: false
  },
  mutation: {
    SNACKBAR_STATUS(state, snackbar) {
      state.snackbarUser = snackbar;
    }
  }
};
